import { useMemo } from 'react';
import { AlertCircle, TrendingDown, AlertTriangle, Activity, TrendingUp, CheckCircle, Loader2, RefreshCw } from 'lucide-react';
import { Card } from '../shared/components/Card';
import { useSettings } from '../shared/contexts/SettingsContext';
import { useProducts } from '../shared/hooks/useProducts';
import { PageTitle} from '../../../../_metronic/layout/core'

export const DashboardPage = () => {
  const settings = {diasCoberturaAlvo:21, leadTime:7}
  const { products, loading, error, refetch } = useProducts();

  const statusCounts = useMemo(() => {
    return {
      ruptura: products.filter((p) => p.status === 'ruptura').length,
      iminente: products.filter((p) => p.status === 'iminente').length,
      minimo: products.filter((p) => p.status === 'minimo').length,
      critica: products.filter((p) => p.status === 'critica').length,
      excesso: products.filter((p) => p.status === 'excesso').length,
      saudavel: products.filter((p) => p.status === 'saudavel').length,
    };
  }, [products]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 text-teal-600 animate-spin" />
          <p className="text-gray-500 text-sm">Carregando dados do estoque...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="flex flex-col items-center gap-4 max-w-md text-center">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <AlertCircle className="w-6 h-6 text-red-600" />
          </div>
          <div>
            <p className="text-gray-900 font-semibold mb-1">Erro ao carregar dados</p>
            <p className="text-gray-500 text-sm">{error}</p>
          </div>
          <button
            onClick={refetch}
            className="flex items-center gap-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium"
          >
            <RefreshCw className="w-4 h-4" />
            Tentar novamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
        <PageTitle>Visão Geral</PageTitle>
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Visão Geral do Estoque</h1>
          <p className="text-gray-600">
            Acompanhamento dos status operacionais dos produtos em tempo real
          </p>
        </div>
        <button
          onClick={refetch}
          className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium text-gray-700 shadow-sm"
        >
          <RefreshCw className="w-4 h-4" />
          Atualizar
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card
          title="Ruptura Instalada"
          value={statusCounts.ruptura}
          icon={<AlertCircle className="w-6 h-6 text-red-600" />}
          color="text-red-600"
          bgColor="bg-red-50"
        />

        <Card
          title="Ruptura Iminente"
          value={statusCounts.iminente}
          icon={<TrendingDown className="w-6 h-6 text-orange-600" />}
          color="text-orange-600"
          bgColor="bg-orange-50"
        />

        <Card
          title="Perto do Minimo"
          value={statusCounts.minimo}
          icon={<AlertTriangle className="w-6 h-6 text-yellow-600" />}
          color="text-yellow-600"
          bgColor="bg-yellow-50"
        />

        <Card
          title="Cobertura Critica"
          value={statusCounts.critica}
          icon={<Activity className="w-6 h-6 text-cyan-600" />}
          color="text-cyan-600"
          bgColor="bg-cyan-50"
        />

        <Card
          title="Excesso"
          value={statusCounts.excesso}
          icon={<TrendingUp className="w-6 h-6 text-blue-600" />}
          color="text-blue-600"
          bgColor="bg-blue-50"
        />

        <Card
          title="Saudavel"
          value={statusCounts.saudavel}
          icon={<CheckCircle className="w-6 h-6 text-green-600" />}
          color="text-green-600"
          bgColor="bg-green-50"
        />
      </div>

      <div className="mt-8 bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Resumo Executivo</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <p className="text-sm text-gray-600 mb-1">Total de Produtos</p>
            <p className="text-2xl font-bold text-gray-900">{products.length}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600 mb-1">Produtos em Alerta</p>
            <p className="text-2xl font-bold text-gray-900">
              {statusCounts.ruptura + statusCounts.iminente + statusCounts.minimo}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-600 mb-1">Lead Time Configurado</p>
            <p className="text-2xl font-bold text-gray-900">{settings.leadTime} dias</p>
          </div>
          <div>
            <p className="text-sm text-gray-600 mb-1">Cobertura Alvo</p>
            <p className="text-2xl font-bold text-gray-900">{settings.diasCoberturaAlvo} dias</p>
          </div>
        </div>
      </div>
    </div>
  );
};
